import { message } from 'antd';
import { createApi } from '@reduxjs/toolkit/query/react';
import baseQueryWith409 from './baseQueryWith409';
import qs from 'qs';
import fetch from 'auth/FetchInterceptor';

// direct fetch without RTK Query
export const getTrabajosEM = query =>
	fetch.get(
		`/trabajos-em${
			query
				? `?${qs.stringify(
						{ ...query, publicationState: 'live' },
						{
							encodeValuesOnly: true,
						}
				  )}`
				: ''
		}`
	);
export const getTrabajoEM = ({ id, query }) =>
	fetch.get(
		`/trabajos-em/${id}${
			query
				? `?${qs.stringify(
						{ ...query, publicationState: 'live' },
						{ encodeValuesOnly: true }
				  )}`
				: ''
		}`
	);
export const addTrabajoEM = data => fetch.post('/trabajos-em', data);
export const updateTrabajoEM = ({ id, ...data }) =>
	fetch.put(`/trabajos-em/${id}`, data);
export const deleteTrabajoEM = id => fetch.delete(`/trabajos-em/${id}`);

// RTK Query
export const trabajosEmApi = createApi({
	reducerPath: 'trabajosEmApi',
	baseQuery: baseQueryWith409,

	// default configuration
	refetchOnReconnect: true,
	refetchOnMountOrArgChange: true,
	refetchOnFocus: true,

	//endpoints
	endpoints: build => ({
		getTrabajosEm: build.query({
			query: query => {
				return {
					url: `/trabajos-em${
						query
							? `?${qs.stringify(
									{ ...query, publicationState: 'live' },
									{
										encodeValuesOnly: true,
									}
							  )}`
							: ''
					}`,
					method: 'GET',
				};
			},
			transformResponse: response => response.data,
			providesTags: result =>
				// is result available?
				result
					? // successful query
					  [
							...result.map(({ id }) => ({ type: 'TrabajosEm', id })),
							{ type: 'TrabajosEm', id: 'LIST' },
					  ]
					: // an error occurred, but we still want to refetch this query when `{ type: 'Posts', id: 'LIST' }` is invalidated
					  [{ type: 'TrabajosEm', id: 'LIST' }],
		}),
		getTrabajoEm: build.query({
			query: ({ id, query }) => {
				return {
					url: `/trabajos-em/${id}${
						query
							? `?${qs.stringify(
									{ ...query, publicationState: 'live' },
									{
										encodeValuesOnly: true,
									}
							  )}`
							: ''
					}`,
					method: 'GET',
				};
			},
			transformResponse: response => response.data,
			providesTags: (result, error, id) => [{ type: 'TrabajosEm', id }],
		}),
		addTrabajoEm: build.mutation({
			query: data => {
				const user = JSON.parse(localStorage.getItem('me'));
				return {
					url: `/trabajos-em`,
					method: 'POST',
					body: JSON.stringify({
						data: {
							...data,
							created_by_user: user.id,
						},
					}),
				};
			},
			onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
				// try catch with antd message when fulfilled and rejected
				try {
					await queryFulfilled;
					message.success('Trabajo Empresa agregado exitosamente');
				} catch (error) {
					message.error('Error al agregar trabajo empresa');
					if (error.error.data?.error) {
						message.error(error.error.data?.error.message);
					}
				}
			},
			invalidatesTags: [{ type: 'TrabajosEm', id: 'LIST' }],
		}),
		updateTrabajoEm: build.mutation({
			query: ({ id, ...data }) => {
				const user = JSON.parse(localStorage.getItem('me'));
				return {
					url: `/trabajos-em/${id}`,
					method: 'PUT',
					body: JSON.stringify({
						data: {
							...data,
							updated_by_user: user.id,
						},
					}),
				};
			},
			onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
				// try catch with antd message when fulfilled and rejected
				try {
					await queryFulfilled;
					message.success('Trabajo Empresa actualizado exitosamente');
				} catch (error) {
					message.error('Error al actualizar trabajo empresa');
					if (error.error.data?.error) {
						message.error(error.error.data?.error.message);
					}
				}
			},
			invalidatesTags: (result, error, { id }) => [
				{ type: 'TrabajosEm', id },
			],
		}),
		deleteTrabajoEm: build.mutation({
			query: id => {
				const user = JSON.parse(localStorage.getItem('me'));
				return {
					url: `/trabajos-em/${id}`,
					method: 'PUT',
					body: JSON.stringify({
						data: {
							publishedAt: null,
							updated_by_user: user.id,
						},
					}),
				};
			},
			onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
				// try catch with antd message when fulfilled and rejected
				try {
					await queryFulfilled;
					message.success('Trabajo Empresa eliminado exitosamente');
				} catch (error) {
					message.error('Error al eliminar trabajo empresa');
					if (error.error.data?.error) {
						message.error(error.error.data?.error.message);
					}
				}
			},
			invalidatesTags: (result, error, id) => [{ type: 'TrabajosEm', id }],
		}),
	}),
});

export const {
	useGetTrabajosEmQuery,
	useGetTrabajoEmQuery,
	useAddTrabajoEmMutation,
	useUpdateTrabajoEmMutation,
	useDeleteTrabajoEmMutation,
} = trabajosEmApi;
